import {
  addDays,
  addMonths,
  endOfDay,
  endOfISOWeek,
  endOfMonth,
  startOfDay,
  startOfISOWeek,
  startOfMonth,
} from 'date-fns'

import { DateFilterType } from './dateFilters'

export const getFromToDatesByFilter: Record<Exclude<DateFilterType, 'custom'>, () => [Date, Date]> & {
  custom: () => [undefined, undefined]
} = {
  thisCalendarWeek: () => {
    const now = new Date()
    return [startOfDay(startOfISOWeek(now)), endOfDay(endOfISOWeek(now))]
  },
  lastCalendarWeek: () => {
    const now = new Date()
    return [startOfDay(startOfISOWeek(addDays(now, -7))), endOfDay(endOfISOWeek(addDays(now, -7)))]
  },
  thisMonth: () => {
    const now = new Date()
    return [startOfDay(startOfMonth(now)), startOfDay(endOfMonth(now))]
  },
  nextMonth: () => {
    const now = new Date()
    return [startOfDay(startOfMonth(addMonths(now, 1))), startOfDay(endOfMonth(addMonths(now, 1)))]
  },
  next7Days: () => {
    const now = new Date()
    return [startOfDay(now), startOfDay(addDays(now, 7))]
  },
  next30Days: () => {
    const now = new Date()
    return [startOfDay(now), startOfDay(addDays(now, 30))]
  },
  next90Days: () => {
    const now = new Date()
    return [startOfDay(now), startOfDay(addDays(now, 90))]
  },
  custom: () => [undefined, undefined],
}
